import React from 'react';
import classNames from 'classnames';
import GoogleMap from 'google-map-react';
import { GeoPosition } from 'react-fns';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import Slide from '@material-ui/core/Slide';
import InputBase from '@material-ui/core/InputBase';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import MyLocation from '@material-ui/icons/MyLocation';
import CloseIcon from '@material-ui/icons/Close';
import PlaceIcon from '@material-ui/icons/Place';
import { withStyles } from '@material-ui/core/styles';
import config from 'utils/config';

const styles = theme => ({
  address: {
    backgroundColor: 'rgba(255, 255, 255, 0.25)',
  },
  marker: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -100%)',
  },
  myLocationButton: {
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: theme.palette.grey[100],
    },
    boxShadow: theme.shadows[2],
    position: 'absolute',
    top: 12,
    right: 8,
  },
});

const Transition = props => <Slide direction="up" {...props} />;

const mapOptions = {
  fullscreenControl: false,
};

class LocationDialog extends React.Component {
  constructor(props) {
    super(props);

    const {
      fullAddress,
      locality,
      latitude: lat,
      longitude: lng,
      placeId: place_id,
    } = props.value;

    this.state = {
      fullAddress,
      locality,
      map: { center: { lat, lng }, zoom: 15 },
      place_id,
      loading: false,
      okButtonDisabled: false,
    };
  }

  handleMapChange = ({ center, zoom }) => {
    this.setState({ map: { center, zoom } });

    if (this.geocoder) {
      this.setState({ loading: true });

      this.geocoder.geocode(
        { location: center, region: 'IN' },
        (results, status) => {
          this.setState({ loading: false });
          if (status === 'OK' && results.length) {
            const {
              formatted_address: fullAddress,
              address_components = [],
              place_id,
              geometry: { location },
            } = results[0];

            const { long_name: locality = '' } =
              address_components.find(({ types }) =>
                types.includes('sublocality_level_1')
              ) || {};

            this.setState({
              fullAddress,
              locality,
              place_id,
              geometry: {
                latitude: location.lat(),
                longitude: location.lng(),
              },
              okButtonDisabled: false,
            });
          } else {
            this.setState({ okButtonDisabled: true });
          }
        }
      );
    }
  };

  handleOkButtonClick = () => {
    const {
      fullAddress,
      locality,
      geometry: { latitude, longitude },
      place_id: placeId,
    } = this.state;

    this.props.onChange({
      fullAddress,
      locality,
      latitude,
      longitude,
      placeId,
    });

    this.props.onClose();
  };

  handleGoogleApiLoaded = ({ maps }) => {
    this.geocoder = new maps.Geocoder();
  };

  render() {
    const { classes, onClose, ...other } = this.props;
    const { fullAddress, map } = this.state;

    return (
      <Dialog
        aria-labelledby="location-dialog-title"
        classes={{ paper: 'h-full' }}
        fullWidth
        onClose={onClose}
        TransitionComponent={Transition}
        {...other}
      >
        <AppBar position="static">
          <Toolbar variant="dense">
            <Typography
              id="location-dialog-title"
              className="flex-grow"
              color="inherit"
              variant="h6"
            >
              Locate Eatery
            </Typography>
            <IconButton color="inherit" onClick={onClose} aria-label="Close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
          <Toolbar variant="dense">
            <InputBase
              className={classNames(classes.address, 'px-2 rounded')}
              classes={{
                disabled: 'text-primary',
              }}
              disabled
              fullWidth
              margin="none"
              spellCheck="false"
              value={fullAddress}
            />
          </Toolbar>
        </AppBar>
        <GeoPosition
          render={({ isLoading, coords, error }) => (
            <div className="h-full relative">
              <GoogleMap
                bootstrapURLKeys={{
                  key: config.mapApiKey,
                }}
                center={map.center}
                onChange={this.handleMapChange}
                onGoogleApiLoaded={this.handleGoogleApiLoaded}
                options={mapOptions}
                zoom={map.zoom}
                yesIWantToUseGoogleMapApiInternals
              />
              {this.state.loading && (
                <LinearProgress
                  className="absolute pin-l pin-t w-full"
                  color="secondary"
                />
              )}
              <IconButton
                className={classes.myLocationButton}
                aria-label="Locate me"
                onClick={() =>
                  coords &&
                  this.handleMapChange({
                    center: { lat: coords.latitude, lng: coords.longitude },
                    zoom: map.zoom,
                  })
                }
              >
                <MyLocation />
              </IconButton>
              <PlaceIcon
                className={classes.marker}
                color="secondary"
                fontSize="large"
              />
            </div>
          )}
        />
        <DialogActions>
          <Button
            onClick={this.handleOkButtonClick}
            color="primary"
            disabled={this.state.okButtonDisabled}
            fullWidth
            variant="contained"
          >
            Done
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withStyles(styles)(withMobileDialog()(LocationDialog));
